'use client';

import React, { useState } from 'react';
import { MAP_CONFIGS, MapConfig } from '@/lib/mapConfigs';

interface MapAngle {
  id: string;
  label: string;
  image?: string;
  mapConfigId?: string;
}

interface MapEntry {
  id: string;
  name: string;
  thumbnail: string;
  angles: MapAngle[];
}

// Only angles with real images are included — no Coming Soon placeholders.
// Maps are sorted alphabetically.
const MAPS: MapEntry[] = [
  {
    id: 'abyss',
    name: 'ABYSS',
    thumbnail: '/assets/images/Loading_Screen_Abyss-1782910652410.webp',
    angles: [
      { id: 'abyss-angle1', label: 'Angle 1', image: '/assets/images/Screenshot_2026-07-02_152116-1783001993338.png', mapConfigId: 'map-abyss-angle1' },
      { id: 'abyss-angle2', label: 'Angle 2', image: '/assets/images/Screenshot_2026-07-02_152149-1783001993500.png', mapConfigId: 'map-abyss-angle2' },
      { id: 'abyss-angle3', label: 'Angle 3', image: '/assets/images/Screenshot_2026-07-02_152306-1783001992320.png', mapConfigId: 'map-abyss-angle3' },
      { id: 'abyss-angle4', label: 'Angle 4', image: '/assets/images/Screenshot_2026-07-02_152344-1783001992937.png', mapConfigId: 'map-abyss-angle4' },
      { id: 'abyss-angle5', label: 'Angle 5', image: '/assets/images/Screenshot_2026-07-02_152837-1783001993392.png', mapConfigId: 'map-abyss-angle5' },
      { id: 'abyss-angle6', label: 'Angle 6', image: '/assets/images/Screenshot_2026-07-02_152927-1783002367789.png', mapConfigId: 'map-abyss-angle6' },
      { id: 'abyss-angle7', label: 'Angle 7', image: '/assets/images/Screenshot_2026-07-02_153021-1783002367098.png', mapConfigId: 'map-abyss-angle7' },
    ],
  },
  {
    id: 'ascent',
    name: 'ASCENT',
    thumbnail: '/assets/images/Loading_Screen_Ascent-1782910652455.webp',
    angles: [
      { id: 'ascent-angle1', label: 'Angle 1', image: '/assets/images/Screenshot_2026-07-02_153646-1783002378317.png', mapConfigId: 'map-ascent-angle1' },
      { id: 'ascent-angle2', label: 'Angle 2', image: '/assets/images/Screenshot_2026-07-02_153722-1783002378048.png', mapConfigId: 'map-ascent-angle2' },
      { id: 'ascent-angle3', label: 'Angle 3', image: '/assets/images/Screenshot_2026-07-02_153749-1783002378600.png', mapConfigId: 'map-ascent-angle3' },
      { id: 'ascent-angle4', label: 'Angle 4', image: '/assets/images/Screenshot_2026-07-02_153837-1783002414030.png', mapConfigId: 'map-ascent-angle4' },
      { id: 'ascent-angle5', label: 'Angle 5', image: '/assets/images/Screenshot_2026-07-02_153854-1783002412681.png', mapConfigId: 'map-ascent-angle5' },
      { id: 'ascent-angle6', label: 'Angle 6', image: '/assets/images/Screenshot_2026-07-02_153909-1783002412671.png', mapConfigId: 'map-ascent-angle6' },
      { id: 'ascent-angle7', label: 'Angle 7', image: '/assets/images/Screenshot_2026-07-02_153925-1783002417529.png', mapConfigId: 'map-ascent-angle7' },
    ],
  },
  {
    id: 'bind',
    name: 'BIND',
    thumbnail: '/assets/images/Loading_Screen_Bind-1782910652448.webp',
    angles: [
      { id: 'bind-angle1', label: 'Angle 1', image: '/assets/images/Screenshot_2026-07-02_154132-1783002418625.png', mapConfigId: 'map-bind-angle1' },
      { id: 'bind-angle2', label: 'Angle 2', image: '/assets/images/Screenshot_2026-07-02_154149-1783003258009.png', mapConfigId: 'map-bind-angle2' },
      { id: 'bind-angle3', label: 'Angle 3', image: '/assets/images/Screenshot_2026-07-02_154207-1783003258011.png', mapConfigId: 'map-bind-angle3' },
      { id: 'bind-angle4', label: 'Angle 4', image: '/assets/images/Screenshot_2026-07-02_154235-1783003258130.png', mapConfigId: 'map-bind-angle4' },
      { id: 'bind-angle5', label: 'Angle 5', image: '/assets/images/Screenshot_2026-07-02_154254-1783003258129.png', mapConfigId: 'map-bind-angle5' },
      { id: 'bind-angle6', label: 'Angle 6', image: '/assets/images/Screenshot_2026-07-02_154314-1783003258138.png', mapConfigId: 'map-bind-angle6' },
      { id: 'bind-angle7', label: 'Angle 7', image: '/assets/images/Screenshot_2026-07-02_154328-1783003263606.png', mapConfigId: 'map-bind-angle7' },
    ],
  },
  {
    id: 'breeze',
    name: 'BREEZE',
    thumbnail: '/assets/images/Loading_Screen_Breeze-1782910652444.webp',
    angles: [
      { id: 'breeze-angle1', label: 'Angle 1', image: '/assets/images/Screenshot_2026-07-02_154507-1783003278474.png', mapConfigId: 'map-breeze-angle1' },
      { id: 'breeze-angle2', label: 'Angle 2', image: '/assets/images/Screenshot_2026-07-02_154525-1783003278461.png', mapConfigId: 'map-breeze-angle2' },
      { id: 'breeze-angle3', label: 'Angle 3', image: '/assets/images/Screenshot_2026-07-02_154558-1783003278418.png', mapConfigId: 'map-breeze-angle3' },
      { id: 'breeze-angle4', label: 'Angle 4', image: '/assets/images/Screenshot_2026-07-02_154613-1783003278498.png', mapConfigId: 'map-breeze-angle4' },
      { id: 'breeze-angle5', label: 'Angle 5', image: '/assets/images/Screenshot_2026-07-02_154626-1783003409963.png', mapConfigId: 'map-breeze-angle5' },
      { id: 'breeze-angle6', label: 'Angle 6', image: '/assets/images/Screenshot_2026-07-02_154650-1783003409972.png', mapConfigId: 'map-breeze-angle6' },
    ],
  },
  {
    id: 'corrode',
    name: 'CORRODE',
    thumbnail: '/assets/images/Loading_Screen_Corrode-1782910652431.webp',
    angles: [
      { id: 'corrode-angle1', label: 'Angle 1', image: '/assets/images/Screenshot_2026-07-02_154852-1783003419631.png', mapConfigId: 'map-corrode-angle1' },
      { id: 'corrode-angle2', label: 'Angle 2', image: '/assets/images/Screenshot_2026-07-02_154908-1783003419663.png', mapConfigId: 'map-corrode-angle2' },
      { id: 'corrode-angle3', label: 'Angle 3', image: '/assets/images/Screenshot_2026-07-02_154925-1783003419572.png', mapConfigId: 'map-corrode-angle3' },
      { id: 'corrode-angle4', label: 'Angle 4', image: '/assets/images/Screenshot_2026-07-02_154959-1783009638065.png', mapConfigId: 'map-corrode-angle4' },
      { id: 'corrode-angle5', label: 'Angle 5', image: '/assets/images/Screenshot_2026-07-02_155016-1783009638032.png', mapConfigId: 'map-corrode-angle5' },
      { id: 'corrode-angle6', label: 'Angle 6', image: '/assets/images/Screenshot_2026-07-02_155044-1783009638062.png', mapConfigId: 'map-corrode-angle6' },
      { id: 'corrode-angle7', label: 'Angle 7', image: '/assets/images/Screenshot_2026-07-02_155102-1783009638042.png', mapConfigId: 'map-corrode-angle7' },
      { id: 'corrode-angle8', label: 'Angle 8', image: '/assets/images/Screenshot_2026-07-02_155129-1783009638043.png', mapConfigId: 'map-corrode-angle8' },
    ],
  },
  {
    id: 'fracture',
    name: 'FRACTURE',
    thumbnail: '/assets/images/Loading_Screen_Fracture-1782910826381.webp',
    angles: [
      { id: 'fracture-angle1', label: 'Angle 1', image: '/assets/images/Screenshot_2026-07-02_155328-1783009655000.png', mapConfigId: 'map-fracture-angle1' },
      { id: 'fracture-angle2', label: 'Angle 2', image: '/assets/images/Screenshot_2026-07-02_155351-1783009655208.png', mapConfigId: 'map-fracture-angle2' },
      { id: 'fracture-angle3', label: 'Angle 3', image: '/assets/images/Screenshot_2026-07-02_155427-1783009655221.png', mapConfigId: 'map-fracture-angle3' },
      { id: 'fracture-angle4', label: 'Angle 4', image: '/assets/images/Screenshot_2026-07-02_155454-1783009655221.png', mapConfigId: 'map-fracture-angle4' },
      { id: 'fracture-angle5', label: 'Angle 5', image: '/assets/images/Screenshot_2026-07-02_155514-1783009655205.png', mapConfigId: 'map-fracture-angle5' },
    ],
  },
  {
    id: 'haven',
    name: 'HAVEN',
    thumbnail: '/assets/images/Loading_Screen_Haven-1782910828369.webp',
    angles: [
      { id: 'haven-angle1', label: 'Angle 1', image: '/assets/images/Screenshot_2026-07-02_155724-1783009908084.png', mapConfigId: 'map-haven-angle1' },
      { id: 'haven-angle2', label: 'Angle 2', image: '/assets/images/Screenshot_2026-07-02_155739-1783009908073.png', mapConfigId: 'map-haven-angle2' },
      { id: 'haven-angle3', label: 'Angle 3', image: '/assets/images/Screenshot_2026-07-02_155754-1783009908065.png', mapConfigId: 'map-haven-angle3' },
      { id: 'haven-angle4', label: 'Angle 4', image: '/assets/images/Screenshot_2026-07-02_155817-1783009908067.png', mapConfigId: 'map-haven-angle4' },
      { id: 'haven-angle5', label: 'Angle 5', image: '/assets/images/Screenshot_2026-07-02_155834-1783009908055.png', mapConfigId: 'map-haven-angle5' },
      { id: 'haven-angle6', label: 'Angle 6', image: '/assets/images/Screenshot_2026-07-02_155852-1783011994316.png', mapConfigId: 'map-haven-angle6' },
    ],
  },
  {
    id: 'icebox',
    name: 'ICEBOX',
    thumbnail: '/assets/images/Loading_Screen_Icebox-1782910829683.webp',
    angles: [
      { id: 'icebox-angle1', label: 'Angle 1', image: '/assets/images/Screenshot_2026-07-02_160052-1783012280932.png', mapConfigId: 'map-icebox-angle1' },
      { id: 'icebox-angle2', label: 'Angle 2', image: '/assets/images/Screenshot_2026-07-02_160109-1783012281075.png', mapConfigId: 'map-icebox-angle2' },
      { id: 'icebox-angle3', label: 'Angle 3', image: '/assets/images/Screenshot_2026-07-02_160125-1783012281035.png', mapConfigId: 'map-icebox-angle3' },
      { id: 'icebox-angle4', label: 'Angle 4', image: '/assets/images/Screenshot_2026-07-02_160146-1783012281087.png', mapConfigId: 'map-icebox-angle4' },
      { id: 'icebox-angle5', label: 'Angle 5', image: '/assets/images/Screenshot_2026-07-02_160212-1783012281097.png', mapConfigId: 'map-icebox-angle5' },
      { id: 'icebox-angle6', label: 'Angle 6', image: '/assets/images/Screenshot_2026-07-02_160230-1783012530317.png', mapConfigId: 'map-icebox-angle6' },
    ],
  },
  {
    id: 'lotus',
    name: 'LOTUS',
    thumbnail: '/assets/images/Loading_Screen_Lotus-1782910831028.webp',
    angles: [
      { id: 'lotus-angle2', label: 'Angle 2', image: '/assets/images/Screenshot_2026-07-02_160640-1783012559583.png', mapConfigId: 'map-lotus-angle2' },
      { id: 'lotus-angle3', label: 'Angle 3', image: '/assets/images/Screenshot_2026-07-02_160656-1783012559697.png', mapConfigId: 'map-lotus-angle3' },
      { id: 'lotus-angle4', label: 'Angle 4', image: '/assets/images/Screenshot_2026-07-02_160711-1783012559682.png', mapConfigId: 'map-lotus-angle4' },
      { id: 'lotus-angle5', label: 'Angle 5', image: '/assets/images/Screenshot_2026-07-02_160723-1783012559568.png', mapConfigId: 'map-lotus-angle5' },
      { id: 'lotus-angle6', label: 'Angle 6', image: '/assets/images/Screenshot_2026-07-02_160459-1783012689318.png', mapConfigId: 'map-lotus-angle6' },
      { id: 'lotus-angle7', label: 'Angle 7', image: '/assets/images/Screenshot_2026-07-02_160520-1783012689429.png', mapConfigId: 'map-lotus-angle7' },
      { id: 'lotus-angle8', label: 'Angle 8', image: '/assets/images/Screenshot_2026-07-02_160539-1783012689326.png', mapConfigId: 'map-lotus-angle8' },
      { id: 'lotus-angle9', label: 'Angle 9', image: '/assets/images/Screenshot_2026-07-02_160550-1783012689416.png', mapConfigId: 'map-lotus-angle9' },
      { id: 'lotus-angle10', label: 'Angle 10', image: '/assets/images/Screenshot_2026-07-02_160607-1783012689426.png', mapConfigId: 'map-lotus-angle10' },
    ],
  },
  {
    id: 'pearl',
    name: 'PEARL',
    thumbnail: '/assets/images/Loading_Screen_Pearl-1782910832348.webp',
    angles: [
      { id: 'pearl-angle1', label: 'Angle 1', image: '/assets/images/Screenshot_2026-07-02_160914-1783012834990.png', mapConfigId: 'map-pearl-angle1' },
      { id: 'pearl-angle2', label: 'Angle 2', image: '/assets/images/Screenshot_2026-07-02_160931-1783012834896.png', mapConfigId: 'map-pearl-angle2' },
      { id: 'pearl-angle3', label: 'Angle 3', image: '/assets/images/Screenshot_2026-07-02_160947-1783012835030.png', mapConfigId: 'map-pearl-angle3' },
      { id: 'pearl-angle4', label: 'Angle 4', image: '/assets/images/Screenshot_2026-07-02_161002-1783012835036.png', mapConfigId: 'map-pearl-angle4' },
      { id: 'pearl-angle5', label: 'Angle 5', image: '/assets/images/Screenshot_2026-07-02_161017-1783012835015.png', mapConfigId: 'map-pearl-angle5' },
      { id: 'pearl-angle6', label: 'Angle 6', image: '/assets/images/Screenshot_2026-07-02_161039-1783013057954.png', mapConfigId: 'map-pearl-angle6' },
      { id: 'pearl-angle7', label: 'Angle 7', image: '/assets/images/Screenshot_2026-07-02_161055-1783013057945.png', mapConfigId: 'map-pearl-angle7' },
    ],
  },
  {
    id: 'split',
    name: 'SPLIT',
    thumbnail: '/assets/images/Loading_Screen_Split-1782910956404.webp',
    angles: [
      { id: 'split-angle1', label: 'Angle 1', image: '/assets/images/Screenshot_2026-07-02_161417-1783013067042.png', mapConfigId: 'map-split-angle1' },
      { id: 'split-angle2', label: 'Angle 2', image: '/assets/images/Screenshot_2026-07-02_161434-1783013067052.png', mapConfigId: 'map-split-angle2' },
      { id: 'split-angle3', label: 'Angle 3', image: '/assets/images/Screenshot_2026-07-02_161451-1783013067003.png', mapConfigId: 'map-split-angle3' },
      { id: 'split-angle4', label: 'Angle 4', image: '/assets/images/Screenshot_2026-07-02_161236-1783013225588.png', mapConfigId: 'map-split-angle4' },
      { id: 'split-angle5', label: 'Angle 5', image: '/assets/images/Screenshot_2026-07-02_161254-1783013225703.png', mapConfigId: 'map-split-angle5' },
      { id: 'split-angle6', label: 'Angle 6', image: '/assets/images/Screenshot_2026-07-02_161320-1783013225682.png', mapConfigId: 'map-split-angle6' },
      { id: 'split-angle7', label: 'Angle 7', image: '/assets/images/Screenshot_2026-07-02_161339-1783013225624.png', mapConfigId: 'map-split-angle7' },
      { id: 'split-angle8', label: 'Angle 8', image: '/assets/images/Screenshot_2026-07-02_161355-1783013225698.png', mapConfigId: 'map-split-angle8' },
    ],
  },
  {
    id: 'summit',
    name: 'SUMMIT',
    thumbnail: '/assets/images/Summit-1782910958939.webp',
    angles: [
      { id: 'summit-angle1', label: 'Angle 1', image: '/assets/images/Screenshot_2026-07-02_161704-1783013561900.png', mapConfigId: 'map-summit-angle1' },
      { id: 'summit-angle2', label: 'Angle 2', image: '/assets/images/Screenshot_2026-07-02_161733-1783013561873.png', mapConfigId: 'map-summit-angle2' },
      { id: 'summit-angle3', label: 'Angle 3', image: '/assets/images/Screenshot_2026-07-02_161751-1783013561894.png', mapConfigId: 'map-summit-angle3' },
      { id: 'summit-angle4', label: 'Angle 4', image: '/assets/images/Screenshot_2026-07-02_161810-1783013561888.png', mapConfigId: 'map-summit-angle4' },
      { id: 'summit-angle5', label: 'Angle 5', image: '/assets/images/Screenshot_2026-07-02_161832-1783013561912.png', mapConfigId: 'map-summit-angle5' },
      { id: 'summit-angle6', label: 'Angle 6', image: '/assets/images/Screenshot_2026-07-02_161844-1783013832889.png', mapConfigId: 'map-summit-angle6' },
      { id: 'summit-angle7', label: 'Angle 7', image: '/assets/images/Screenshot_2026-07-02_161901-1783013832930.png', mapConfigId: 'map-summit-angle7' },
      { id: 'summit-angle8', label: 'Angle 8', image: '/assets/images/Screenshot_2026-07-02_161915-1783013832896.png', mapConfigId: 'map-summit-angle8' },
    ],
  },
  {
    id: 'sunset',
    name: 'SUNSET',
    thumbnail: '/assets/images/Loading_Screen_Sunset-1782910957617.webp',
    angles: [
      { id: 'sunset-angle1', label: 'Angle 1', image: '/assets/images/Screenshot_2026-07-02_162113-1783012008522.png', mapConfigId: 'map-sunset-angle1' },
      { id: 'sunset-angle2', label: 'Angle 2', image: '/assets/images/Screenshot_2026-07-02_162129-1783012008508.png', mapConfigId: 'map-sunset-angle2' },
      { id: 'sunset-angle3', label: 'Angle 3', image: '/assets/images/Screenshot_2026-07-02_162143-1783012008528.png', mapConfigId: 'map-sunset-angle3' },
      { id: 'sunset-angle4', label: 'Angle 4', image: '/assets/images/Screenshot_2026-07-02_162212-1783012008516.png', mapConfigId: 'map-sunset-angle4' },
      { id: 'sunset-angle5', label: 'Angle 5', image: '/assets/images/Screenshot_2026-07-02_162227-1783012091910.png', mapConfigId: 'map-sunset-angle5' },
      { id: 'sunset-angle6', label: 'Angle 6', image: '/assets/images/Screenshot_2026-07-02_162247-1783012093636.png', mapConfigId: 'map-sunset-angle6' },
      { id: 'sunset-angle7', label: 'Angle 7', image: '/assets/images/Screenshot_2026-07-02_162259-1783012098183.png', mapConfigId: 'map-sunset-angle7' },
    ],
  },
];

const glassStyle: React.CSSProperties = {
  background: 'rgba(12, 12, 18, 0.82)',
  backdropFilter: 'blur(28px) saturate(180%)',
  WebkitBackdropFilter: 'blur(28px) saturate(180%)',
  border: '1px solid rgba(255,255,255,0.09)',
  boxShadow: '0 8px 40px rgba(0,0,0,0.55), inset 0 1px 0 rgba(255,255,255,0.07)',
};

interface MapMenuPanelProps {
  onMapSelect?: (map: MapConfig, backgroundImage?: string) => void;
}

// AngleImage: renders angle preview with error handling
function AngleImage({ src, alt }: { src: string; alt: string }) {
  const [errored, setErrored] = useState(false);

  if (errored) {
    return (
      <div
        className="w-full h-full flex flex-col items-center justify-center gap-1"
        style={{ background: 'rgba(255,60,60,0.08)' }}
      >
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" style={{ opacity: 0.5 }}>
          <circle cx="10" cy="10" r="8" stroke="rgba(255,100,100,0.7)" strokeWidth="1.5" />
          <path d="M10 6v5M10 14v1" stroke="rgba(255,100,100,0.7)" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
        <span
          className="text-center px-2"
          style={{ color: 'rgba(255,100,100,0.6)', fontSize: '8px', letterSpacing: '0.06em', lineHeight: 1.3 }}
        >
          Failed to load:{'\n'}{src.split('/').pop()}
        </span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className="w-full h-full object-cover"
      onError={() => setErrored(true)}
    />
  );
}

export default function MapMenuPanel({ onMapSelect }: MapMenuPanelProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedMap, setSelectedMap] = useState<MapEntry | null>(null);

  const handleMapClick = (map: MapEntry) => {
    setSelectedMap(map);
  };

  const handleAngleSelect = (angle: MapAngle) => {
    if (!angle.mapConfigId) return;
    if (onMapSelect) {
      const config = MAP_CONFIGS.find((m) => m.id === angle.mapConfigId);
      if (config) {
        onMapSelect(config, angle.image);
      }
    }
    setIsOpen(false);
    setSelectedMap(null);
  };

  const handleBack = () => {
    setSelectedMap(null);
  };

  const handleClose = () => {
    setIsOpen(false);
    setSelectedMap(null);
  };

  // Only show maps that have at least one configured angle
  const mapsWithAngles = MAPS.filter((m) => m.angles.length > 0);
  const mapsWithoutAngles = MAPS.filter((m) => m.angles.length === 0);
  // Show all maps in the list but only show angles for maps that have them
  const allMaps = [...mapsWithAngles, ...mapsWithoutAngles];

  return (
    <>
      {/* Hamburger button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-center w-9 h-9 rounded-xl transition-all duration-150 pointer-events-auto"
        style={{
          background: isOpen ? 'rgba(0,212,255,0.15)' : 'rgba(255,255,255,0.06)',
          border: `1px solid ${isOpen ? 'rgba(0,212,255,0.3)' : 'rgba(255,255,255,0.1)'}`,
          cursor: 'pointer',
        }}
        title="Maps"
      >
        <svg width="16" height="14" viewBox="0 0 16 14" fill="none">
          <rect x="0" y="0" width="16" height="2" rx="1" fill={isOpen ? '#00D4FF' : 'rgba(255,255,255,0.7)'} />
          <rect x="0" y="6" width="16" height="2" rx="1" fill={isOpen ? '#00D4FF' : 'rgba(255,255,255,0.7)'} />
          <rect x="0" y="12" width="16" height="2" rx="1" fill={isOpen ? '#00D4FF' : 'rgba(255,255,255,0.7)'} />
        </svg>
      </button>

      {/* Panel */}
      {isOpen && (
        <div
          className="absolute top-12 right-0 z-50 rounded-2xl overflow-hidden"
          style={{ ...glassStyle, width: '280px', maxHeight: '80vh' }}
        >
          {/* Header */}
          <div
            className="flex items-center justify-between px-4 py-3"
            style={{ borderBottom: '1px solid rgba(255,255,255,0.07)' }}
          >
            {selectedMap ? (
              <>
                <button
                  onClick={handleBack}
                  className="flex items-center gap-2 text-xs font-semibold tracking-widest uppercase transition-colors hover:text-white"
                  style={{ color: 'rgba(255,255,255,0.5)', cursor: 'pointer', background: 'none', border: 'none' }}
                >
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M9 2L4 7l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  Back
                </button>
                <span
                  className="text-xs font-bold tracking-widest uppercase"
                  style={{ color: 'rgba(232,232,240,0.9)', letterSpacing: '0.10em', fontSize: '10px' }}
                >
                  {selectedMap.name} — ANGLES
                </span>
              </>
            ) : (
              <span
                className="text-xs font-semibold tracking-widest uppercase"
                style={{ color: 'rgba(232,232,240,0.9)', letterSpacing: '0.12em' }}
              >
                Select Map
              </span>
            )}
            <button
              onClick={handleClose}
              className="w-6 h-6 flex items-center justify-center rounded-lg transition-colors hover:bg-white/10"
              style={{ color: 'rgba(255,255,255,0.4)', cursor: 'pointer', background: 'none', border: 'none' }}
            >
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M1 1l8 8M9 1L1 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </button>
          </div>

          {/* Content */}
          <div className="overflow-y-auto" style={{ maxHeight: 'calc(80vh - 52px)' }}>
            {!selectedMap ? (
              /* Map list — alphabetical */
              <div className="p-2 space-y-1.5">
                {allMaps.map((map) => {
                  const hasAngles = map.angles.length > 0;
                  return (
                    <button
                      key={map.id}
                      onClick={() => hasAngles && handleMapClick(map)}
                      className="w-full relative overflow-hidden rounded-xl transition-all duration-150"
                      style={{
                        height: '64px',
                        cursor: hasAngles ? 'pointer' : 'default',
                        border: '1px solid rgba(255,255,255,0.08)',
                        opacity: hasAngles ? 1 : 0.45,
                      }}
                    >
                      <div
                        className="absolute inset-0"
                        style={{
                          backgroundImage: `url(${map.thumbnail})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                        }}
                      />
                      <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.38)' }} />
                      <div className="absolute inset-0 flex items-center justify-center">
                        <span
                          className="font-extrabold tracking-widest"
                          style={{
                            color: '#FFFFFF',
                            fontSize: '18px',
                            letterSpacing: '0.15em',
                            textShadow: '0 2px 8px rgba(0,0,0,0.8)',
                            fontFamily: 'var(--font-sans)',
                          }}
                        >
                          {map.name}
                        </span>
                      </div>
                      {hasAngles && (
                        <div className="absolute right-3 top-1/2 -translate-y-1/2">
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                            <path d="M5 2l5 5-5 5" stroke="rgba(255,255,255,0.6)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      )}
                    </button>
                  );
                })}
              </div>
            ) : (
              /* Angle list — only real-image slots, no Coming Soon */
              <div className="p-2 space-y-2">
                {selectedMap.angles.length === 0 ? (
                  <div className="py-8 flex flex-col items-center gap-2" style={{ color: 'rgba(255,255,255,0.3)' }}>
                    <span className="text-xs tracking-widest uppercase" style={{ fontSize: '10px' }}>No angles available</span>
                  </div>
                ) : (
                  selectedMap.angles.map((angle) => (
                    <div
                      key={angle.id}
                      className="rounded-xl overflow-hidden transition-all duration-150 cursor-pointer hover:scale-[1.01]"
                      style={{ border: '1px solid rgba(255,255,255,0.10)' }}
                      onClick={() => handleAngleSelect(angle)}
                    >
                      <div
                        className="w-full relative"
                        style={{ height: '120px', background: 'rgba(255,255,255,0.04)' }}
                      >
                        {angle.image ? (
                          <AngleImage src={angle.image} alt={`${selectedMap.name} ${angle.label}`} />
                        ) : (
                          <div
                            className="w-full h-full flex items-center justify-center"
                            style={{
                              backgroundImage: `url(${selectedMap.thumbnail})`,
                              backgroundSize: 'cover',
                              backgroundPosition: 'center',
                            }}
                          >
                            <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.45)' }} />
                          </div>
                        )}
                      </div>
                      <div
                        className="px-3 py-2 flex items-center justify-between"
                        style={{ background: 'rgba(255,255,255,0.03)' }}
                      >
                        <span
                          className="text-xs font-semibold"
                          style={{ color: 'rgba(232,232,240,0.85)', letterSpacing: '0.06em' }}
                        >
                          {angle.label}
                        </span>
                        <span className="text-xs" style={{ color: 'rgba(0,212,255,0.7)', fontSize: '9px', letterSpacing: '0.08em' }}>
                          SELECT →
                        </span>
                      </div>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
